import React, { lazy } from 'react';
import { Map } from 'lucide-react';
interface EmbeddedMapProps {
  destinationLat: number | null;
  destinationLng: number | null;
  className?: string;
}
export function EmbeddedMap({
  destinationLat,
  destinationLng,
  className = ''
}: EmbeddedMapProps) {
  const hasCoords = destinationLat && destinationLng;
  if (!hasCoords) {
    return <div className={`w-full h-56 rounded-2xl bg-[#1A1A1A] border border-white/10 flex items-center justify-center ${className}`} data-id="element-909">
        <div className="text-center" data-id="element-910">
          <Map className="w-10 h-10 text-white/15 mx-auto mb-2" data-id="element-911" />
          <p className="text-white/30 text-sm" data-id="element-912">Mapa no disponible</p>
        </div>
      </div>;
  }
  const embedUrl = `https://www.google.com/maps?q=${destinationLat},${destinationLng}&z=15&output=embed`;
  return <div className={`w-full h-56 rounded-2xl overflow-hidden border border-white/10 bg-[#1A1A1A] ${className}`} data-id="element-913">
      <iframe key={`${destinationLat}-${destinationLng}`} src={embedUrl} className="w-full h-full" loading="lazy" allowFullScreen referrerPolicy="no-referrer-when-downgrade" title="Mapa de destino" data-id="element-914" />
    </div>;
}